import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-54b00f49"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "caodi"
};
const _hoisted_2 = {
  class: ""
};
const _hoisted_3 = {
  class: "base"
};
const _hoisted_4 = {
  style: {
    "padding-top": "1rem",
    "text-align": "center",
    "font-size": "0.34rem",
    "margin-bottom": "0.1rem"
  }
};
const _hoisted_5 = {
  style: {
    "padding-top": "0rem",
    "text-align": "center",
    "font-size": "0.4rem",
    "font-weight": "700"
  }
};
const _hoisted_6 = {
  class: "el-dialog__body",
  style: {
    "border": "1px solid #eeeeee"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont",
  style: {
    "font-size": "0.3rem",
    "color": "#1ba27a",
    "padding-right": "0.2rem"
  }
}, "", -1));
const _hoisted_8 = {
  class: "d-flex"
};
const _hoisted_9 = {
  class: "el-form-item w-100"
};
const _hoisted_10 = {
  class: "el-form-item__label"
};
const _hoisted_11 = {
  class: "el-form-item__content"
};
const _hoisted_12 = {
  class: "el-input"
};
const _hoisted_13 = ["placeholder"];
const _hoisted_14 = {
  key: 0,
  style: {
    "color": "blue",
    "font-size": "0.26rem",
    "margin-bottom": "0.1rem"
  }
};
const _hoisted_15 = {
  class: "d-flex"
};
const _hoisted_16 = {
  class: "el-form-item w-100 is-required"
};
const _hoisted_17 = {
  for: "name",
  class: "el-form-item__label"
};
const _hoisted_18 = {
  class: "el-form-item__content"
};
const _hoisted_19 = {
  class: "el-input"
};
const _hoisted_20 = {
  class: "el-form-item"
};
const _hoisted_21 = {
  key: 0,
  class: "el-form-item__content",
  style: {
    "width": "auto",
    "padding-top": "0.2rem"
  }
};
const _hoisted_22 = {
  style: {
    "font-size": "0.24rem",
    "text-align": "center",
    "margin-top": "0.3rem",
    "margin-bottom": "0.1rem"
  }
};
const _hoisted_23 = {
  class: "el-form-item",
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_24 = {
  class: "el-form-item__content"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont",
  style: {
    "font-size": "0.3rem",
    "color": "#ff9800",
    "padding-right": "0.2rem"
  }
}, "", -1));
const _hoisted_26 = {
  class: "d-flex"
};
const _hoisted_27 = {
  class: "el-form-item w-100"
};
const _hoisted_28 = {
  class: "el-form-item__label"
};
const _hoisted_29 = {
  class: "el-form-item__content"
};
const _hoisted_30 = {
  class: "el-input"
};
const _hoisted_31 = ["placeholder"];
const _hoisted_32 = {
  key: 0,
  style: {
    "color": "blue",
    "font-size": "0.26rem",
    "margin-bottom": "0.1rem"
  }
};
const _hoisted_33 = {
  class: "d-flex"
};
const _hoisted_34 = {
  class: "el-form-item w-100 is-required"
};
const _hoisted_35 = {
  for: "name",
  class: "el-form-item__label"
};
const _hoisted_36 = {
  class: "el-form-item__content"
};
const _hoisted_37 = {
  class: "el-input"
};
const _hoisted_38 = ["value"];
const _hoisted_39 = {
  key: 0,
  style: {
    "color": "skyblue",
    "font-size": "0.24rem",
    "margin-bottom": "0.2rem"
  }
};
const _hoisted_40 = {
  key: 1,
  style: {
    "width": "80%",
    "margin": "0 auto",
    "padding-top": "0.3rem"
  }
};
const _hoisted_41 = {
  class: "d-grid gap-2"
};
const _hoisted_42 = {
  key: 0,
  style: {
    "text-align": "center",
    "font-size": "0.34rem",
    "color": "#fd560f"
  }
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "0.5rem"
  }
}, null, -1));
const _hoisted_44 = {
  style: {
    "color": "#718096",
    "font-size": "0.24rem",
    "margin-bottom": "0.1rem"
  }
};
const _hoisted_45 = {
  style: {
    "color": "#718096",
    "font-size": "0.24rem",
    "margin-bottom": "0.1rem"
  }
};
const _hoisted_46 = {
  style: {
    "color": "red",
    "font-size": "0.24rem",
    "margin-bottom": "0.1rem"
  }
};
const _hoisted_47 = {
  style: {
    "color": "#718096",
    "font-size": "0.24rem",
    "margin-bottom": "0.1rem"
  }
};
const _hoisted_48 = {
  style: {
    "color": "#718096",
    "font-size": "0.24rem",
    "margin-bottom": "0.1rem"
  }
};
const _hoisted_49 = {
  class: "content"
};
const _hoisted_50 = {
  style: {
    "font-weight": "100"
  }
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1rem"
  }
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_radio = _resolveComponent("van-radio");
  const _component_van_radio_group = _resolveComponent("van-radio-group");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_Footer = _resolveComponent("Footer");
  const _component_Ce = _resolveComponent("Ce");
  const _component_P = _resolveComponent("P");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  const _component_van_back_top = _resolveComponent("van-back-top");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    onClickLeft: $options.back,
    onClickRight: $options.onClickLeft
  }, {
    left: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "arrow-left",
      color: "#061c3c"
    }), _createTextVNode(" " + _toDisplayString($data.lang.u1), 1)]),
    right: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.a14), 1)]),
    _: 1
  }, 8, ["onClickLeft", "onClickRight"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString($data.lang.t2), 1), _createElementVNode("h3", _hoisted_5, _toDisplayString($data.user.jinbi), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_tabs, {
    active: $data.select.type,
    "onUpdate:active": _cache[6] || (_cache[6] = $event => $data.select.type = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, null, {
      title: _withCtx(() => [_hoisted_7, _createTextVNode(_toDisplayString($data.lang.t3), 1)]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("label", _hoisted_10, _toDisplayString($data.lang.t7), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("input", {
        type: "number",
        autocomplete: "off",
        placeholder: $data.lang.t7,
        class: "el-input__inner",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.select.price = $event)
      }, null, 8, _hoisted_13), [[_vModelText, $data.select.price]]), $data.select.fabi != null && $data.select.type == 1 && $data.select.price > 0 ? (_openBlock(), _createElementBlock("p", _hoisted_14, " ≈" + _toDisplayString($data.select.fabi.img) + " " + _toDisplayString($options.result), 1)) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("label", _hoisted_17, _toDisplayString($data.lang.t5), 1), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_van_radio_group, {
        modelValue: $data.select.address,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.select.address = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_van_radio, {
          name: 'BEP20'
        }, {
          default: _withCtx(() => [_createTextVNode(" BEP20")]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.qb, (item, index) => {
          return _openBlock(), _createBlock(_component_van_radio, {
            name: item.img,
            key: index
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])])])])]), _createElementVNode("div", _hoisted_20, [$data.select.address && $data.select.address != 'BEP20' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("p", _hoisted_22, _toDisplayString($data.select.address), 1), _createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        size: "small",
        "native-type": "submit",
        color: "#E91E63",
        style: {
          "width": "auto",
          "margin": "0 auto"
        },
        onClick: _cache[2] || (_cache[2] = $event => $options.copyToClipboard($data.select.address))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.a5), 1)]),
        _: 1
      })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        "native-type": "submit",
        color: "#061c3c",
        onClick: _cache[3] || (_cache[3] = $event => $options.up())
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.a3), 1)]),
        _: 1
      })])])]),
      _: 1
    }), _createVNode(_component_van_tab, null, {
      title: _withCtx(() => [_hoisted_25, _createTextVNode(_toDisplayString($data.lang.t4), 1)]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("label", _hoisted_28, _toDisplayString($data.lang.t7), 1), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_withDirectives(_createElementVNode("input", {
        type: "text",
        autocomplete: "off",
        placeholder: $data.lang.t7,
        class: "el-input__inner",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.select.price = $event)
      }, null, 8, _hoisted_31), [[_vModelText, $data.select.price]]), $data.select.fabi != null && $data.select.type == 1 && $data.select.price > 0 ? (_openBlock(), _createElementBlock("p", _hoisted_32, " ≈" + _toDisplayString($data.select.fabi.img) + " " + _toDisplayString($options.result), 1)) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("label", _hoisted_35, _toDisplayString($data.lang.a7), 1), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_withDirectives(_createElementVNode("select", {
        class: "form-select",
        "aria-label": "Default select example",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.select.fabi = $event)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bank, (item, index) => {
        return _openBlock(), _createElementBlock("option", {
          value: item,
          key: index
        }, _toDisplayString(item.img), 9, _hoisted_38);
      }), 128))], 512), [[_vModelSelect, $data.select.fabi]])])])])]), $data.select.fabi != null ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString($data.select.fabi.img) + _toDisplayString($data.select.fabi.lv) + "=1usdt ", 1)) : _createCommentVNode("", true), $data.select.fabi != null ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.select.fabi.list, (item, index) => {
        return _openBlock(), _createBlock(_component_van_button, {
          round: "",
          block: "",
          type: "primary",
          "native-type": "submit",
          key: index,
          color: "#061c3c",
          onClick: $event => $options.bank111(item.id)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128)), $data.select.fabi.list.length <= 0 ? (_openBlock(), _createElementBlock("p", _hoisted_42, [_createVNode(_component_van_icon, {
        name: "warning-o"
      }), _createTextVNode(" " + _toDisplayString($data.select.fabi.img) + " " + _toDisplayString($data.lang.aa6), 1)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["active"]), _hoisted_43, _createElementVNode("p", _hoisted_44, _toDisplayString($data.lang.aa1), 1), _createElementVNode("p", _hoisted_45, _toDisplayString($data.lang.aa2), 1), _createElementVNode("p", _hoisted_46, _toDisplayString($data.lang.aa3), 1), _createElementVNode("p", _hoisted_47, _toDisplayString($data.lang.aa4), 1), _createElementVNode("p", _hoisted_48, _toDisplayString($data.lang.aa5), 1)])])]), _createVNode(_component_Footer, {
    lang_list: $data.lang_list,
    lang: $data.lang
  }, null, 8, ["lang_list", "lang"]), _createVNode(_component_Ce, {
    lang: $data.lang,
    user: $data.user,
    active: "-1"
  }, null, 8, ["lang", "user"])]), _createVNode(_component_van_action_sheet, {
    show: $data.show,
    "onUpdate:show": _cache[7] || (_cache[7] = $event => $data.show = $event),
    title: $data.lang.t5
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_49, [_createElementVNode("h2", null, [_createTextVNode(_toDisplayString($data.lang.t9), 1), _createElementVNode("span", _hoisted_50, "(" + _toDisplayString($data.lang.tu9) + ")", 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.qb, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index
      }, [_createElementVNode("h3", null, _toDisplayString(item.title), 1), _createVNode(_component_P, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.img), 1)]),
        _: 2
      }, 1024), _createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        size: "small",
        "native-type": "submit",
        color: "#061c3c",
        onClick: $event => $options.copyToClipboard(item.img)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.a5), 1)]),
        _: 2
      }, 1032, ["onClick"])]);
    }), 128)), _hoisted_51])]),
    _: 1
  }, 8, ["show", "title"]), _createVNode(_component_van_back_top, {
    bottom: "10vh",
    style: {
      "background-color": "#061c3c"
    }
  })]);
}